import { SectionKey } from "./PolicyEditorPage";

export const SECTION_TITLES: Readonly<Record<SectionKey, string>> = {
  requestor: "Identity",
  resource: "Resource(s)",
  approval: "Actions",
};
